import { ValueOf } from '../../utilities/types';

const enrollmentSteps = {
  STEP_UP: 'step-up',
  PAIR: 'pair',
  RECOVERY_CODES: 'recovery-codes',
  STATUS: 'status',
} as const;

export type EnrollmentStep = ValueOf<typeof enrollmentSteps>;

export const deriveEnrollmentStep = ({
  hasRecoveryCodes,
  hasPendingEnrollment,
  isSteppingUp,
}: {
  hasRecoveryCodes: boolean;
  hasPendingEnrollment: boolean;
  isSteppingUp: boolean;
}): EnrollmentStep => {
  if (hasRecoveryCodes) return enrollmentSteps.RECOVERY_CODES;
  if (hasPendingEnrollment) return enrollmentSteps.PAIR;
  if (isSteppingUp) return enrollmentSteps.STEP_UP;
  return enrollmentSteps.STATUS;
};

export default enrollmentSteps;
